<div class="floating-services" *ngIf="!isCompanyUser">
  <div class="floating-services__backdrop" [class.floating-services__backdrop--open]="isOpen"></div>

  <div class="floating-services__radial" [class.floating-services__radial--open]="isOpen">
    <button
      *ngFor="let item of serviceItems; let i = index"
      type="button"
      class="floating-services__shortcut"
      [class.floating-services__shortcut--visible]="isOpen"
      [class.floating-services__shortcut--active]="isActiveRoute(item.route)"
      [style.transitionDelay]="isOpen ? (i * 45) + 'ms' : ((serviceItems.length - 1 - i) * 25) + 'ms'"
      [style.right.px]="isOpen ? getItemRight(i) : 0"
      [style.bottom.px]="isOpen ? getItemBottom(i) : 0"
      [attr.aria-label]="item.label"
      [title]="item.label"
      (click)="navigate(item.route, $event)"
    >
      <i class="bi" [ngClass]="item.icon"></i>
    </button>
  </div>

  <button
    type="button"
    class="floating-services__toggle"
    [class.floating-services__toggle--open]="isOpen"
    [attr.aria-expanded]="isOpen"
    aria-label="Services"
    (click)="toggleMenu($event)"
  >
    <i class="bi" [ngClass]="isOpen ? 'bi-x-lg' : 'bi-plus-lg'"></i>
  </button>
</div>
